import src from "IMAGE";
export default { src, width: 360, height: 134, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARklEQVR42m2KwQpAQBQA9/8/kJOLEpHW45V9ljc4rJPD1DRNiOa8yOGse6adlDldlB6KLOmk6iJ1MyD2M8hDvxmjGpr9G27o8VyxrNrczQAAAABJRU5ErkJggg=="};
